export function disconnectConnection(state) {
  if (state.connection) {
    state.connection.close()
  }
}
export function disconnectChatConnection(state) {
  if (state.chatConnection) {
    state.chatConnection.close()
  }
}
export function updateConnection(state, payload) {
  state.connection = payload
}
export function updateChatConnection(state, payload) {
  state.chatConnection = payload
}
export function updateConnecting(state, payload) {
  state.connecting = payload
}
export function updateConnected(state, payload) {
  state.connected = payload
}
export function setUnreadChatCount(state, payload) {
  state.unreadChatCount = Math.max(0, Number(payload) || 0)
}
export function incrementUnreadChatCount(state, payload = 1) {
  state.unreadChatCount = Math.max(0, (Number(state.unreadChatCount) || 0) + (Number(payload) || 1))
}
